<div class="profile-pills" role="tablist">
  <a
    class="profile-pills__item"
    [class.is-active]="isActive('/edit-profile')"
    routerLink="/edit-profile"
    [queryParams]="{ overview: '1' }"
    role="tab"
    [attr.aria-selected]="isActive('/edit-profile')"
  >
    <span [translate]="'GREATER.OVERVIEW'">Overview</span>
  </a>

  <a
    class="profile-pills__item"
    [class.is-active]="isActive('/bank-account')"
    [class.is-disabled]="!profileComplete"
    [attr.aria-disabled]="!profileComplete"
    [attr.aria-selected]="isActive('/bank-account')"
    routerLink="/bank-account"
    (click)="onDisabledClick($event, profileComplete)"
    role="tab"
  >
    <span [translate]="'GREATER.BANK_ACCOUNT'">Bank Account</span>
  </a>

  <a
    class="profile-pills__item"
    [class.is-active]="isActive('/presentation')"
    [class.is-disabled]="!stripeVerified"
    [attr.aria-disabled]="!stripeVerified"
    [attr.aria-selected]="isActive('/presentation')"
    routerLink="/presentation"
    (click)="onDisabledClick($event, stripeVerified)"
    role="tab"
  >
    <span>Subscriptions</span>
  </a>
</div>
